export const isNil = (val: unknown) => val == undefined;
export const dec2hex = (dec: number) => `0${dec.toString(16)}`.substr(-2);
export const base64urlEncode = (hashed: ArrayBuffer) => {
  let str = '';

  const bytes = new Uint8Array(hashed);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const generateHash = (plain: string, algo: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);

  return window.crypto.subtle.digest(algo, data);
};

// Меняет ключ K в объекте O на значение V и возвращает модифицированный O
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ChangeObjKey<O extends Record<string, any>, K extends keyof O, V> = {
  [Key in keyof O]: Key extends K ? V : O[Key];
};
